var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Wrap an async function with callbacks for success and error
 *
 * Created to circumvent removal of onSuccess & onError from tanstack query in v5
 *
 * @param f the function to wrap
 * @param onSuccess callback for success
 * @param onError callback for error
 *
 * @internal
 */
const wrapAsync = 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(f, { onSuccess, onError, }) => {
    return (...params) => __awaiter(void 0, void 0, void 0, function* () {
        let result;
        try {
            result = yield f(...params);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
        }
        catch (e) {
            onError === null || onError === void 0 ? void 0 : onError(e);
            throw e;
        }
        return result;
    });
};
export default wrapAsync;
//# sourceMappingURL=wrapAsync.js.map